import {
  Develop as DevelopIcon,
  Goal as GoalIcon,
  Delete as DeleteIcon,
  MyOneOnOne as MyOneOnOneIcon,
  GoalsThin as GoalsThinIcon,
  CompetenciesThin as CompetenciesThinIcon,
  OneOnOneThin as OneOnOneThinIcon,
  Help2 as Help2Icon,
} from '@mesh.ai/rabbit';
import { getUserL2Access } from 'Deer/helpers/getUserAccess';

import type { ActionPlanItemReferenceType, ActionPlanItemTag } from './types';

export const API_KEYS_TAGS = {
  GOAL: 'GOAL',
  ONE_ON_ONE: 'ONE_ON_ONE',
  COMPETENCY_IDP: 'COMPETENCY_IDP',
};

export const REVIEW_ACTIONS = {
  GOAL: 'GOAL',
  ONE_ON_ONE: 'ONE_ON_ONE',
  COMPETENCY_IDP: 'COMPETENCY_IDP',
  EXPLAIN_WHY: 'EXPLAIN_WHY',
  DELETE: 'DELETE',
} as const;

export const ACTION_BUTTON_OPTIONS = {
  [REVIEW_ACTIONS.GOAL]: {
    label: (module: string) => `Create a ${module || 'goal'}`,
    Icon: GoalIcon,
    hasAccess: () => getUserL2Access().hasGoalAccess,
    header: REVIEW_ACTIONS.GOAL,
  },
  [REVIEW_ACTIONS.ONE_ON_ONE]: {
    label: () => 'Discuss in next 1:1',
    Icon: MyOneOnOneIcon,
    hasAccess: () => getUserL2Access().hasOneOnOneAccess,
    header: REVIEW_ACTIONS.ONE_ON_ONE,
  },
  [REVIEW_ACTIONS.COMPETENCY_IDP]: {
    label: () => 'Add to competency',
    Icon: DevelopIcon,
    hasAccess: () => getUserL2Access().hasIDPAccess,
    header: REVIEW_ACTIONS.COMPETENCY_IDP,
  },
  [REVIEW_ACTIONS.EXPLAIN_WHY]: {
    label: () => 'Explain why',
    Icon: Help2Icon,
    hasAccess: () => true,
    header: REVIEW_ACTIONS.EXPLAIN_WHY,
  },
  [REVIEW_ACTIONS.EXPLAIN_WHY]: {
    label: () => 'Explain why',
    Icon: Help2Icon,
    hasAccess: () => true,
    header: REVIEW_ACTIONS.EXPLAIN_WHY,
  },
  [REVIEW_ACTIONS.DELETE]: {
    label: () => 'Delete',
    Icon: DeleteIcon,
    hasAccess: () => true,
    header: REVIEW_ACTIONS.DELETE,
  },
};

export const REVIEWEE_LIST_COLUMN_DEF = [
  {
    displayName: 'Reviewee name',
    id: '1',
  },
  {
    displayName: 'Action items',
    id: '2',
  },
  {
    displayName: 'Last activity',
    id: '3',
  },
];

export const TABLE_COLUMNS_DISPLAYNAME = {
  REVIEWEE_NAME: 'Reviewee name',
  ACTION_ITEMS: 'Action items',
  LAST_ACTIVITY: 'Last activity',
};

export const EDIT_SCREEN_TITLE = 'Post review action plan';

export const REVIEW_ACTION_ITEM_TAG_MAP = {
  [API_KEYS_TAGS.GOAL]: REVIEW_ACTIONS.GOAL,
  [API_KEYS_TAGS.ONE_ON_ONE]: REVIEW_ACTIONS.ONE_ON_ONE,
  [API_KEYS_TAGS.COMPETENCY_IDP]: REVIEW_ACTIONS.COMPETENCY_IDP,
} as const;

export const CATEGORIES_TAG_MAP: Record<keyof typeof REVIEW_ACTION_CATEGORIES_OPTIONS, ActionPlanItemTag> = {
  [REVIEW_ACTIONS.GOAL]: REVIEW_ACTIONS.GOAL,
  [REVIEW_ACTIONS.COMPETENCY_IDP]: REVIEW_ACTIONS.COMPETENCY_IDP,
  [REVIEW_ACTIONS.ONE_ON_ONE]: REVIEW_ACTIONS.ONE_ON_ONE,
} as const;

export const CATEGORIES_REFERENCE_TYPE_MAP: Record<
  keyof typeof REVIEW_ACTION_CATEGORIES_OPTIONS,
  ActionPlanItemReferenceType
> = {
  [REVIEW_ACTIONS.GOAL]: 'GOAL',
  [REVIEW_ACTIONS.COMPETENCY_IDP]: 'COMPETENCY_INITIATIVE',
  [REVIEW_ACTIONS.ONE_ON_ONE]: 'ONE_ON_ONE_AGENDA_ITEM',
} as const;

export const REVIEW_ACTION_CATEGORIES_OPTIONS = {
  [REVIEW_ACTIONS.GOAL]: {
    label: 'Goals',
    icon: GoalsThinIcon,
    hasAccess: (): boolean => getUserL2Access().hasGoalAccess,
  },
  [REVIEW_ACTIONS.ONE_ON_ONE]: {
    label: '1:1',
    icon: OneOnOneThinIcon,
    hasAccess: (): boolean => getUserL2Access().hasOneOnOneAccess,
  },
  [REVIEW_ACTIONS.COMPETENCY_IDP]: {
    label: 'Competencies',
    icon: CompetenciesThinIcon,
    hasAccess: (): boolean => getUserL2Access().hasIDPAccess,
  },
} as const;
